module.exports = __webpack_public_path__ + "static/media/Spitalfields (9).571a8686.JPG";